var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditorMarkerSecondary = function SvgEditorMarkerSecondary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 41,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    d: "M12.5.75C6.01.75.75 6.01.75 12.5c0 9.94 11.75 27.75 11.75 27.75S24.25 22.44 24.25 12.5C24.25 6.01 18.99.75 12.5.75Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 5,
    fill: "#fff"
  })));
};
export { SvgEditorMarkerSecondary as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCAyNSA0MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjUgMC43NUM2LjAwOTY1IDAuNzUgMC43NSA2LjAwOTY1IDAuNzUgMTIuNUMwLjc1IDIyLjQ0MDUgMTIuNSA0MC4yNSAxMi41IDQwLjI1QzEyLjUgNDAuMjUgMjQuMjUgMjIuNDQwNSAyNC4yNSAxMi41QzI0LjI1IDYuMDA5NjUgMTguOTkwMyAwLjc1IDEyLjUgMC43NVoiIGZpbGw9IiM2NjY2NjYiIHN0cm9rZT0iIzRBNEE0QSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPGNpcmNsZSBjeD0iMTIuNSIgY3k9IjEyLjUiIHI9IjUiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";